import { WorkflowLayout, WorkflowLayoutProps } from "@portal/components/layout/WorkflowLayout";
import { AdminUserMenu } from "../settings/AdminUserMenu";
import { AdminHeaderActionButtons } from "../shared/AdminHeaderActionButtons";

export const AdminWorkflowLayout = (
	props: Omit<WorkflowLayoutProps, "userMenu" | "headerActionButtons">,
) => {
	return (
		<WorkflowLayout
			userMenu={<AdminUserMenu />}
			headerActionButtons={<AdminHeaderActionButtons />}
			{...props}
		/>
	);
};
